import React from "react";
import Contracts from "../../Contracts";
import CardSection from "../../../../components/ui/card/CardSection";
import ImportModelContractCosts from "./features/importModelContractCosts/ImportModelContractCosts";
import ExportModelContractCosts from "./features/exportModelContractCosts/ExportModelContractCosts";

const ModelContractCosts = () => {
  return (
    <div className="contract-reports-section">
      <div className="scrollable-table-sec">
        <div className="row">
          <div className="col-6 pl-1">
            <CardSection
              cardTitle="Import Model Contract Costs"
              customHeader={true}
            >
              <ImportModelContractCosts />
            </CardSection>
          </div>
          <div className="col-6">
            <CardSection
              cardTitle="Export Model Contract Costs"
              customHeader={true}
            >
              <ExportModelContractCosts />
            </CardSection>
          </div>
        </div>
      </div>
    </div>
    // <UnderConstruction/>
  );
};

export default Contracts(ModelContractCosts);
